import React, { Suspense, lazy } from 'react'
import { motion } from 'framer-motion'
import { styles } from '../../styles'

// const StarsCanvas = lazy(() => import('../canvas/Stars'));
// const WarriorCanvas = lazy(() => import('../canvas/Warrior'));

const Hero = () => {
  return (
    <section className='relative w-full h-[98vh] sm:h-screen mx-auto'>
      <div className={`${styles.paddingX} max-w-7xl h-full mx-auto flex flex-col sm:flex-row items-center justify-center sm:justify-between gap-5`}>

        <div className={`${styles.heroHeadText} w-full md:w-3/4 text-white relative text-center sm:text-left z-[1]`}>
          <div className='hidden sm:flex flex-col justify-center items-center mt-5 absolute -top-3 -left-5'>
            <div className='w-5 h-5 rounded-full bg-biggie' />
            <div className='w-1 sm:h-80 h-40 violet-gradient' />
          </div>
          <h1 className=''>Welcome to <br /> <span className='text-biggie'>Perilous Games</span></h1>
          <p className={`${styles.heroSubText} mt-5 text-white-100`}>
            Where Gaming Adventures Come to Life!
          </p>
          <p className={`${styles.heroSubText} mt-5 text-white-100`}>
            Dive into Dangerous Worlds with Perilous Games! 🎮
          </p>
        </div>

        <div className='hidden sm:block h-full w-full md:w-1/2 absolute right-0 top-[150px] z-0'>
          {/* <Suspense fallback={null}>
            <WarriorCanvas />
          </Suspense> */}
        </div>
      </div>

      <div className='absolute bottom-6 z-10 sm:bottom-8 w-full flex justify-center items-center'>
        <a href='#about' aria-label='Go to About Section'>
          <div className='w-[35px] h-[58px] rounded-3xl border-4 border-secondary flex justify-center items-start p-2'>
            <motion.div
              animate={{
                y: [0, 24, 0]
              }}
              transition={{
                duration: 1.5,
                repeat: Infinity,
                repeatType: 'loop'
              }}
              className='w-3 h-3 bg-secondary rounded-full'
            />
          </div>
        </a>
      </div>
      {/* <Suspense fallback={null}>
        <StarsCanvas />
      </Suspense> */}
    </section>
  )
}

export default Hero
